'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tab = require('../Tab');

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ListTabs = _glamorous2.default.ul({
  paddingLeft: 0,
  listStyle: 'none',
  margin: 0
});

var TabTitleItem = _glamorous2.default.li({
  display: 'inline-block',
  paddingRight: 5,
  paddingLeft: 5,
  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  padding: '16px 30px',
  cursor: 'pointer',
  opacity: '0.4',
  ':hover': {
    opacity: 1
  }
}, function (props) {
  return props.isActiveTab && {
    transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    cursor: 'default',
    opacity: 1
  };
});

var ActiveTabBorder = _glamorous2.default.div({
  height: 4,
  position: 'absolute',
  bottom: 0,
  transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  willChange: 'left, width'
}, function (props) {
  return props.activeTabElement && {
    width: props.activeTabElement.offsetWidth,
    left: props.activeTabElement.offsetLeft
  };
});

var TabAnchorItem = _glamorous2.default.a({
  textTransform: 'capitalize',
  color: '#000000',
  fontWeight: 600
});

var TabsContainer = _glamorous2.default.div({
  position: 'relative',
  borderBottom: '1px solid #dfdfdf'
});

var ReactTabs = _glamorous2.default.div({
  position: 'realative'
});

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      tabs: [],
      prevActiveTab: {},
      activeTab: _this.props.activeTab,
      tabsElements: []
    }, _this.onClick = function (tab) {
      return function (event) {
        _this.setState(function (prevState, props) {
          if (_this.props.onChange(tab, prevState)) {
            return {
              prevActiveTab: prevState.activeTab,
              activeTab: tab
            };
          }
        });
      };
    }, _this.removeTab = function (tabId) {
      _this.setState(function (prevState, props) {
        return {
          tabs: prevState.tabs.filter(function (tab) {
            return tab.id !== tabId;
          })
        };
      });
    }, _this.addTab = function (newTab) {
      var isNewTabFound = void 0;

      for (var i in _this.state.tabs) {
        var tab = _this.state.tabs[i];

        if (tab.id === newTab.id) {
          isNewTabFound = true;
          break;
        }
      }

      if (!isNewTabFound) {
        _this.setState(function (prevState, props) {
          return {
            tabs: prevState.tabs.concat(newTab)
          };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tabs, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(ReactTabs, null, _react2.default.createElement(TabsContainer, null, _react2.default.createElement(ListTabs, null, this.state.tabs.map(function (tab, index) {
        return _react2.default.createElement(TabTitleItem, {
          key: index,
          onClick: _this2.onClick(tab),
          id: tab.id,
          innerRef: function innerRef(tabElement) {
            if (!_this2.state.tabsElements[tab.id]) {
              _this2.setState(function (prevState, props) {
                var tabsElements = prevState.tabsElements;
                tabsElements[tab.id] = tabElement;
                return {
                  tabsElements: tabsElements
                };
              });
            }
          },
          isActiveTab: _this2.state.activeTab.id === tab.id
        }, _react2.default.createElement(TabAnchorItem, null, tab.title));
      })), _react2.default.createElement(ActiveTabBorder, {
        style: {
          background: this.props.color || '#1D71B8'
        },
        color: this.props.color,
        activeTabElement: this.state.tabsElements[this.state.activeTab.id]
      })), _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          activeTab: _this2.state.activeTab,
          addTab: _this2.addTab
        });
      }));
    }
  }]);

  return Tabs;
}(_react.Component);

Tabs.Tab = _Tab2.default;
Tabs.propTypes = {
  onChange: _propTypes2.default.func
};
Tabs.defaultProps = {
  onChange: function onChange() {
    return true;
  }
};
exports.default = Tabs;
Tabs.__docgenInfo = [{
  'description': '',
  'displayName': 'Tabs',
  'methods': [{
    'name': 'onClick',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'tab',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'removeTab',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'tabId',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'addTab',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'newTab',
      'type': null
    }],
    'returns': null
  }],
  'props': {
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {\n  return true;\n}',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Tabs/index.js'] = {
    name: 'Tabs',
    docgenInfo: Tabs.__docgenInfo,
    path: 'src/Tabs/index.js'
  };
}